import * as React from 'react';
import './LabelTag.scss';

export type LabelTagProps = {
  /**
   * `duplicate`: one of several copies; `missing`: referenced, not held;
   * `gap`: an amendment number the chain skips.
   */
  tone: 'duplicate' | 'missing' | 'gap';
  title?: string;
  children: React.ReactNode;
};

/**
 * The ledger's version tag, for what the explorer says about a document: that
 * it has copies, or that the chain refers to it but nobody has uploaded it.
 */
export const LabelTag: React.FC<LabelTagProps> = ({
  tone,
  title,
  children,
}) => (
  <span className={`tree-label-${tone}`} title={title}>
    {children}
  </span>
);
